import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconGeoDomainSizeM(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M7.2891 11H4V1H7.35545C8.31912 1 9.14692 1.2002 9.83886 1.60059C10.534 1.99772 11.0679 2.56901 11.4408 3.31445C11.8136 4.0599 12 4.95182 12 5.99023C12 7.0319 11.812 7.92708 11.436 8.67578C11.0632 9.42448 10.5245 9.99902 9.8199 10.3994C9.11848 10.7998 8.27488 11 7.2891 11ZM5.75829 9.43262H7.20379C7.87994 9.43262 8.44392 9.30566 8.89573 9.05176C9.34755 8.7946 9.6872 8.41211 9.91469 7.9043C10.1422 7.39323 10.2559 6.75521 10.2559 5.99023C10.2559 5.22526 10.1422 4.59049 9.91469 4.08594C9.6872 3.57812 9.35071 3.19889 8.90521 2.94824C8.46287 2.69434 7.91311 2.56738 7.25592 2.56738H5.75829V9.43262Z" />
      <path d="M3 3.88944V1L0.0253126 10.3509C-0.0550553 10.6035 0.062303 10.8814 0.28744 10.9716C0.512577 11.0618 0.760237 10.9301 0.840605 10.6775L1.66623 8.08213H3V7.11072H1.97525L3 3.88944Z" />
    </svg>
  )
}

export const IconGeoDomain = createIcon({
  l: IconGeoDomainSizeM,
  m: IconGeoDomainSizeM,
  s: IconGeoDomainSizeM,
  xs: IconGeoDomainSizeM,
  name: 'IconGeoDomain',
})
